var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Popover, Box, TextField } from "@mui/material";
import { RgbaColorPicker } from "react-colorful";
import { colorToHex8, hex8ToRgba } from "../utils/color.util";
var CAlphaColorPicker = function (_a) {
    var color = _a.color, onChange = _a.onChange, externalAnchorEl = _a.anchorEl, externalOnClose = _a.onClose;
    var _b = useState(null), internalAnchorEl = _b[0], setInternalAnchorEl = _b[1];
    var _c = useState({ r: 0, g: 0, b: 0, a: 1 }), internalColor = _c[0], setInternalColor = _c[1];
    var _d = useState(color), inputValue = _d[0], setInputValue = _d[1];
    var isControlled = externalAnchorEl !== undefined;
    var anchorEl = isControlled ? externalAnchorEl : internalAnchorEl;
    useEffect(function () {
        var rgba = hex8ToRgba(color);
        if (rgba) {
            if (rgba.r !== internalColor.r ||
                rgba.g !== internalColor.g ||
                rgba.b !== internalColor.b ||
                Math.abs(rgba.a - internalColor.a) > 0.01) {
                setInternalColor(rgba);
            }
            setInputValue(color);
        }
    }, [color]);
    var open = Boolean(anchorEl);
    var handleOpen = function (event) { return setInternalAnchorEl(event.currentTarget); };
    var handleClose = function () {
        if (isControlled)
            externalOnClose === null || externalOnClose === void 0 ? void 0 : externalOnClose();
        else
            setInternalAnchorEl(null);
    };
    var handleColorChange = function (newColor) {
        setInternalColor(newColor);
        var hex = colorToHex8(newColor);
        setInputValue(hex);
        onChange(hex);
    };
    var handleInputChange = function (e) {
        var val = e.target.value;
        setInputValue(val);
        var rgba = hex8ToRgba(val);
        if (rgba) {
            setInternalColor(rgba);
            onChange(val);
        }
    };
    return (_jsxs(_Fragment, { children: [!isControlled && (_jsx(Box, { onClick: handleOpen, sx: {
                    width: 40,
                    height: 35,
                    borderRadius: 1,
                    border: "1px solid #ccc",
                    backgroundColor: color,
                    cursor: "pointer",
                    display: "inline-block",
                }, title: color })), _jsxs(Popover, __assign({ open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: { vertical: "bottom", horizontal: "left" }, PaperProps: {
                    sx: { p: 2, width: 260, height: 320, display: 'flex', flexDirection: 'column' },
                } }, { children: [_jsx(RgbaColorPicker, { color: internalColor, onChange: handleColorChange, style: { flexGrow: 1, borderRadius: 8, width: "100%" } }), _jsx(TextField, { fullWidth: true, value: inputValue, onChange: handleInputChange, placeholder: "#RRGGBBAA", sx: { mt: 2 } })] }))] }));
};
export default CAlphaColorPicker;
